<template>
	<MailQueueList :show-actions="!readonly" />
</template>

<script lang="ts">
	import {Vue, Component, Prop} from 'vue-property-decorator';
	import Icon from "@/plugins/icons";
	import MailQueueList from "@/components/mail-queue/admin/MailQueueList.vue";

	@Component({
		components: {MailQueueList}
	})
	export default class ServicesTabMailQueue extends Vue {

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private icons = Icon;

	}
</script>

<style scoped lang="scss">

</style>